import { BeneficiaryRepository } from "@beneficiary/data/repositories/beneficiary.repository";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

@injectable()
export class UpdateBeneficiaryDocumentsUseCase {
    constructor(
        @inject(BeneficiaryRepository)
        private readonly beneficiaryRepository: BeneficiaryRepository,
    ) {}

    async execute(
        beneficiaryId: number,
        documentIds: number[],
    ): Promise<boolean> {
        const updateResult = await this.beneficiaryRepository.updateDocuments(
            beneficiaryId,
            documentIds,
        );

        if (updateResult.isLeft()) {
            ToastManagerStore.error(updateResult.getLeftOrThrow().message);
            return false;
        }

        return true;
    }
}
